import { render, staticRenderFns } from "./dyform.vue?vue&type=template&id=fd7c63e2&scoped=true"
import script from "./dyform.vue?vue&type=script&lang=js"
export * from "./dyform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7c63e2",
  null
  
)

export default component.exports